import React from  "react"
import { useState, useEffect, useRef} from "react"
import { Formik, Form, useField, FormikProps } from 'formik';
import * as Yup from 'yup';
import axios from "axios";
import CommonVars from "../Component/CommonVars";
import {
    Flex,
    Heading,
    Input,
    Button,  
    Stack,
    chakra,
    Box,
    Link,
    Avatar,
  } from "@chakra-ui/react";
  import { FaUserAlt, FaLock } from "react-icons/fa";


  const MyTextField = ({ label, ...props }) => {
    const [field, meta, helpers] = useField(props);
    return (
      <>
        <label>
          {label}
        </label>

        <Input {...field} {...props} />
        {meta.touched && meta.error ? (
          <div className="error">{meta.error}</div>
        ) : null}
      </>
    );
  };


function AddProductScreen(props){

    useEffect(()=>{
        var form = document.querySelector("form");;
        form.addEventListener("submit", function(event){
        event.preventDefault()
        });
    }, [])

    const errRef = useRef();
    const successRef = useRef();
    const [errMsg, setErrMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const token = localStorage.getItem('token')
    const headers = {
        "Content-Type": "application/json",
    }
    return(
        <Formik
            initialValues={{
                name: '',
                price: '',
                description:'',
                categoryid:''
            }}

        validationSchema={Yup.object({
            name: Yup.string()
            .required('Product Name is required!'),
            price:Yup.string()
            .required('Price is required!'),
            description : Yup.string()
            .required('Add in description!'),
            categoryid: Yup.string()
            .required('Category needed'),
        })}



        onSubmit = {values =>{
          const formData = new FormData();
          const file = document.getElementById('image').files[0];
          formData.append('image', file);
          const name = String(values.name);
          const description = String(values.description)
          const price = parseInt(values.price)
          const categoryid = String(values.categoryid)
          console.log(file)
            axios.post(`${CommonVars.API_URL}/upload`, formData,{headers:{Authorization : `Bearer ${token}`} })
            .then((res) =>{
              console.log(res)
              const pdtImage = res.data
              console.log(pdtImage)
              
            const productbody = {
              name : name,
              description : description,
              image : pdtImage,
              price : price,
              categoryid : categoryid
            }
            axios.post(`${CommonVars.API_URL}/products `, productbody,{headers:{Authorization : `Bearer ${token}`} },{
              headers: headers
          })
          .then((response)=>{
              console.log(response)
              alert("Product Added")
              window.location.href="/";
          })
            })
            
    
            
           
        }

        }
        >
                    {props => (

     <Box
     flexDirection="column"
      width="100wh"
      height="110vh"
      backgroundColor="gray.200"
      justifyContent="center"
      alignItems="center">

    
      <Stack
        flexDir="column"
        mb="2"
        justifyContent="center"
        alignItems="center"
      >
        <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"}>{errMsg}</p> 
        <p ref={successRef} className={successMsg ? "successmsg" : "offscreen"}>{successMsg}</p>
    
        <Heading color="black.400">Add Product</Heading>
        <Box minW={{ base: "90%", md: "468px" }}>

          <Form>
            <Stack
              spacing={4}
              p="1rem"
              backgroundColor="whiteAlpha.900"
              boxShadow="md"
            >
                   <MyTextField name="name" type="username" label="Product Name" />
                   <MyTextField name="price" type="fullname" label="Price" />
                   <Input id="image" h={'32px'} padding={'-20'} type="file" label="Image" />
                   <MyTextField name="description" type="description" label="Description"/>
                   <MyTextField name="categoryid" type="category" label="Category"/>
              <Button
                borderRadius={0}
                type="submit"
                variant="solid"
                colorScheme="gray"
                width="full"
              >
                                    {props.isSubmitting ? 'Adding...' : 'Add Product'}
              </Button>
            </Stack>
          </Form>

        </Box>
      </Stack>
      </Box>
                     )}
        </Formik>
    )

}

export default AddProductScreen;